import React, { useState, useEffect, useRef } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { FaChevronDown, FaChevronUp, FaBars, FaTimes } from "react-icons/fa";
import styles from "./Header.module.css";
import { SettingService } from "../../services/setting_service";
import config from "../../config/config";

const Header = () => {
  const settingService = SettingService();
  const [settingData, setSettingData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [imageErrors, setImageErrors] = useState({});
  const [isLeagueOpen, setIsLeagueOpen] = useState(false);
  const [isSportOpen, setIsSportOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 1108);

  const mobileMenuRef = useRef(null);
  const hamburgerRef = useRef(null);
  const location = useLocation();
  const toggleLeague = () => setIsLeagueOpen(!isLeagueOpen);
  const isSportActive = location.pathname === "/cricket-league" ||
    location.pathname.includes("league");
  const toggleSport = () => {
    setIsSportOpen(!isSportOpen);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  useEffect(() => {
    const fetchSettingData = async () => {
      try {
        await settingService.fetchAllSetting(setSettingData);
      } catch (error) {
        console.error("Error fetching data", error);
      } finally {
        setLoading(false);
      }
    };
    fetchSettingData();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const mobileBreakpoint = 1108;
      const isMobile = window.innerWidth <= mobileBreakpoint;
      setIsMobileView(isMobile);

      if (!isMobile && isMobileMenuOpen) {
        setIsMobileMenuOpen(false);
        setIsSportOpen(false);
        setIsLeagueOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);

    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [isMobileMenuOpen]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        mobileMenuRef.current &&
        !mobileMenuRef.current.contains(event.target) &&
        hamburgerRef.current &&
        !hamburgerRef.current.contains(event.target)
      ) {
        setIsMobileMenuOpen(false);
        setIsSportOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleImageError = (settingId) => {
    setImageErrors((prev) => ({ ...prev, [settingId]: true }));
  };

  const getFullImageUrl = (logoPath) => {
    if (!logoPath) return null;

    if (logoPath.startsWith("http")) {
      return logoPath;
    }
    return `${config.baseURL}${logoPath}`;
  };

  const handleNavLinkClick = () => {
    if (isMobileView) {
      setIsMobileMenuOpen(false);
      setIsSportOpen(false);
      setIsLeagueOpen(false);
    }
  };

  const handleMouseEnterSport = () => {
    if (!isMobileView) {
      setIsSportOpen(true);
    }
  };

  const handleMouseLeaveSport = () => {
    if (!isMobileView) {
      setIsSportOpen(false);
    }
  };

  const handleSportClick = () => {
    if (isMobileView) {
      setIsSportOpen(!isSportOpen);
    }
  };

  return (
    <header className={styles.header}>
      <div className={settingData?.logo ? styles.container : styles.container2}>
        {/* Logo Section */}
        {settingData && (
          <div className={styles.logoSection}>
            {settingData.logo && (
              <>
                <NavLink to="/" >
                  <img
                  className={styles.logoSize}
                    src={getFullImageUrl(settingData.logo)}
                    // style={{ height: "60px" }}
                    onError={() => handleImageError(settingData.id)}
                    alt="Royal Sports League"
                  />
                </NavLink>
                <NavLink to="/" 
                style={{ textDecoration: "none",color:'black' }}
                >

                <h1 className={styles.logoText}>Royal Sports League</h1>
                </NavLink>

              </>
            )}
          </div>
        )}

        {!isMobileView && (
          <nav
            className={`${settingData?.logo ? styles.navLinks : styles.navLinks2}`}
          >
            <NavLink to="/" className={({ isActive }) =>
              isActive ? `${styles.navItem} ${styles.active}` : styles.navItem
            }>
              Home
            </NavLink>
            <NavLink to="/about" className={({ isActive }) =>
              isActive ? `${styles.navItem} ${styles.active}` : styles.navItem
            }>
              About Us
            </NavLink>

            <div
              className={styles.dropdown}
              onMouseEnter={handleMouseEnterSport}
              onMouseLeave={handleMouseLeaveSport}
            >
              <div
                className={`${styles.navItem} ${isSportActive ? styles.activeLink : ""}`}
                style={{ cursor: 'pointer' }}
                onClick={handleSportClick}
              >
                <span className={styles.dropdownTrigger}>
                  Sports {isSportOpen ? (
                    <FaChevronUp className={styles.arrowIcon} />
                  ) : (
                    <FaChevronDown className={styles.arrowIcon} />
                  )}
                </span>
              </div>

              {isSportOpen && (
                <div className={styles.dropdownMenu}>
                  <NavLink
                    to="/cricket-league"
                    className={({ isActive }) => isActive ? `${styles.dropdownItem} ${styles.activeSubItem}` : styles.dropdownItem}
                    onClick={handleNavLinkClick}
                  >
                    Cricket League
                  </NavLink>
                </div>
              )}
            </div>

            <NavLink to="/event" className={({ isActive }) =>
              isActive ? `${styles.navItem} ${styles.active}` : styles.navItem
            }>
              Events
            </NavLink>
            <NavLink to="/news" className={({ isActive }) =>
              isActive ? `${styles.navItem} ${styles.active}` : styles.navItem
            }>
              News
            </NavLink>
            <NavLink to="/gallery-video" className={({ isActive }) =>
              isActive ? `${styles.navItem} ${styles.active}` : styles.navItem
            }>
              Gallery
            </NavLink>
            <NavLink to="/contact" className={({ isActive }) =>
              isActive ? `${styles.navItem} ${styles.active}` : styles.navItem
            }>
              Contact Us
            </NavLink>
          </nav>
        )}

        {isMobileView && isMobileMenuOpen && (
          <nav
            ref={mobileMenuRef}
            className={`${settingData?.logo ? styles.navLinks : styles.navLinks2} ${styles.navLinksMobile}`}
          >
            <NavLink to="/" className={({ isActive }) =>
              isActive ? `${styles.navItem} ${styles.active}` : styles.navItem
            } onClick={handleNavLinkClick}>
              Home
            </NavLink>
            <NavLink to="/about" className={({ isActive }) =>
              isActive ? `${styles.navItem} ${styles.active}` : styles.navItem
            } onClick={handleNavLinkClick}>
              About Us
            </NavLink>

            <div
      className={styles.dropdown}
      onMouseEnter={handleMouseEnterSport}
      onMouseLeave={handleMouseLeaveSport}
    >
      <div
        className={`${styles.navItem} ${isSportActive ? styles.activeLink : ""}`}
        style={{ cursor: 'pointer' }}
        onClick={handleSportClick}
      >
        <span className={styles.dropdownTrigger}>
          Sports {isSportOpen ? (
            <FaChevronUp className={styles.arrowIcon} />
          ) : (
            <FaChevronDown className={styles.arrowIcon} />
          )}
        </span>
      </div>

      {isSportOpen && (
        <div className={styles.dropdownMenu}>
          <NavLink 
            to="/cricket-league" 
            className={({ isActive }) => isActive ? `${styles.dropdownItem} ${styles.activeSubItem}` : styles.dropdownItem}
            onClick={handleNavLinkClick}
          >
            Cricket League
          </NavLink>
        </div>
      )}
    </div>


            <NavLink to="/event" className={({ isActive }) =>
              isActive ? `${styles.navItem} ${styles.active}` : styles.navItem
            } onClick={handleNavLinkClick}>
              Events
            </NavLink>
            <NavLink to="/news" className={({ isActive }) =>
              isActive ? `${styles.navItem} ${styles.active}` : styles.navItem
            } onClick={handleNavLinkClick}>
              News
            </NavLink>
            <NavLink to="/gallery-video" className={({ isActive }) =>
              isActive ? `${styles.navItem} ${styles.active}` : styles.navItem
            } onClick={handleNavLinkClick}>
              Gallery
            </NavLink>
            <NavLink to="/contact" className={({ isActive }) =>
              isActive ? `${styles.navItem} ${styles.active}` : styles.navItem
            } onClick={handleNavLinkClick}>
              Contact Us
            </NavLink>
          </nav>
        )}

        <div className={styles.rightSection}>
          {isMobileView && (
            <div
              ref={hamburgerRef}
              className={styles.mobileMenuIcon}
              onClick={toggleMobileMenu}
            >
              {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;